<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"></i>
          </div>
          <div>
            <h2
              class="clean-section-title has-text-white has-text-weight-bold is-paddingless"
            >
              خدمات إعادة المطالبة
            </h2>
            <h3
              class="subtitle is-5 pt-10 pb-10 has-text-white has-text-weight-bold"
            >
              يمكنك من خلالها التقدم بطلب استرجاع مبالغ مخصومة نتيجة حركات
              (شراء/سحب) غير ناجحة.
            </h3>
          </div>
        </div>
        <h2></h2>
        <div class="columns is-vcentered">
          <!-- <div class="column is-4">
            <router-link to="/services/refund/card">
              <div
                class="flex-card icon-card-hover first-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link">
                  إعادة المطالبة بكروت الشحن
                </h3>
                <p class="card-description">
                  نظراً لعدم نجاح عملية شراء كرت دفع مسبق لشركة (ليبيانا –
                  المدار – ليبيا للاتصالات) عن طريق خدمة الصحارى موبايل ، فإنه
                  يمكنك التقدم بالاعتراض عن العملية للعمل على ترجيع المبلغ إلى
                  حسابك من خلال هذا البند .
                </p>
              </div>
            </router-link>
          </div>

          <div class="column is-4">
            <router-link to="/services/refund/mobicash">
              <div
                class="flex-card icon-card-hover first-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link">
                  إعادة المطالبة موبي كاش
                </h3>
                <p class="card-description">
                  نتيجة لعدم نجاح عملية الشراء عن طريق خدمة موبي كاش باستخدام
                  الهاتف النقال ، فإنه يمكنك التقدم بالاعتراض عن العملية للعمل
                  على ترجيع المبلغ إلى حسابك من خلال هذا البند .
                </p>
              </div>
            </router-link>
          </div> -->

          <div class="column is-4">
            <router-link to="/services/refund/atm">
              <div
                class="flex-card icon-card-hover first-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link">
                  إعادة المطالبة صراف آلي ATM
                </h3>
                <p class="card-description">
                  بسبب عدم استلامك للمبلغ المالي المخصوم من حسابك بسبب استخدامك
                  لآلة السحب الذاتي ، نظرا لعدم نجاح حركة السحب أو غيره من
                  الأسباب ، فإنه يمكنك التقدم بطلب الاعتراض عن حركة السحب من هنا
                  لإعادة المبلغ إلى حسابك .
                </p>
              </div>
            </router-link>
          </div>

          <div class="column is-4">
            <router-link to="/services/refund/pos">
              <div
                class="flex-card icon-card-hover first-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link">
                  إعادة المطالبة من أجهزة نقاط البيع
                </h3>
                <p class="card-description">
                  نتيجة لعدم نجاح عملية الشراء من أجهزة نقاط البيع ، فإنه يمكنك
                  التقدم بالاعتراض عن العملية للعمل على ترجيع المبلغ إلى حسابك
                  من خلال هذا البند .
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div
        class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
      >
        <router-link to="/portal">
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
            <b>عودة للرئيسية</b>
          </a>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "mobile",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "refund/balanceCard",
      requestInfo: {},
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeRequest(actionstring, action, url) {
      this.$router.push({
        name: "servicerequest",
        params: {
          requeststring: actionstring,
          requestid: action,
          requesturl: this.url,
        },
      });
    },
  },
};
</script>
